import React, { useEffect, useMemo, useState } from 'react';
import { IFlowManager } from '../interfaces';
import { YearsSelector } from './YearsSelector';
import { Wrapper } from './generate/Wrapper';
import { checkIfShouldShowSideBar, exportAndSortYearsList } from '../utils';
import { STYLES } from '../consts';
import { Layout } from '../../../components/Layout/Layout';

const { FLOW_MANAGER } = STYLES;

export const FlowManager = ({ list, activeYear }: IFlowManager) => {
  const [selectedFormYear, setSelectedFormYear] = useState<number>(0);
  const shouldShowSideBar = useMemo(() => {
    if (!list) return false;
    return checkIfShouldShowSideBar({ list });
  }, [list]);

  const yearsList = useMemo(() => {
    const yList = exportAndSortYearsList(list);
    setSelectedFormYear(activeYear || yList[0]);
    return yList;
  }, [list, shouldShowSideBar]);

  const activeFormData = useMemo(() => {
    if (!selectedFormYear) return null;
    return list.filter((item) => item.year === selectedFormYear)[0];
  }, [selectedFormYear, yearsList]);

  useEffect(() => {
    if (activeYear) {
      setSelectedFormYear(activeYear);
    }
  }, [activeYear]);

  const shouldSkipIntro = useMemo(() => list.some((item) => item.fileCreated), [list]);

  return (
    <Layout wrapperClassName={FLOW_MANAGER.WRAPPER}>
      <div className={FLOW_MANAGER.WRAPPER}>
        {shouldShowSideBar && (
          <YearsSelector
            handleYearSelection={(y) => setSelectedFormYear(y)}
            activeYear={selectedFormYear}
            yearsList={yearsList}
          />
        )}
        {activeFormData && <Wrapper shouldSkipIntro={shouldSkipIntro} activeFormData={activeFormData} />}
        {!activeFormData && (
          <div
            className='w-[456px] h-full rounded-[8px]  flex items-center justify-center shadow-light bg-surface-primary-bw-00'
          >
            There are no reports yet.
          </div>
        )}
      </div>
    </Layout>
  );
};
